<ui-modal modalTitle="Customise your workspace" size="md" [scrollable]="true">
	<p class="text-secondary">The changes you make here only affect you and not anyone else in your organisation.</p>

	<h6 class="text-bold">Modules</h6>
	<p class="text-secondary text-small">Drag modules to change their order in your sidebar.</p>
	<div class="scrollable mb-4" (cdkDropListDropped)="itemDrop($event)" cdkDropList>
		<div *ngFor="let item of items" class="text-waikawagrey draggable hoverable d-flex align-items-center p-3 border-bottom" cdkDrag>
			<i class="wq wq-drag-indicator text-silver mr-3"></i>
			<img *ngIf="item.iconUrl" [src]="item.iconUrl" class="nav-svg-icon mr-2" alt="">
			<i *ngIf="!item.iconUrl && item.icon" class="{{item.icon}} mr-2"></i>
			<span>{{item.description}}</span>
		</div>
	</div>

	<!-- Only offered to people who can have the widget in the first place: a switch for something
	     permission already withholds is a promise the app won't keep. -->
	<ng-container *ngIf="app.crmEnabled">
		<h6 class="text-bold">Widgets</h6>
		<p class="text-secondary text-small">Choose which widgets remain available while you work.</p>
		<div class="d-flex align-items-center p-3 border rounded">
			<i class="wq wq-note text-silver mr-3"></i>
			<div class="flex-weight-1 min-width-0">
				<div>Needs Your Attention</div>
				<div class="text-secondary text-small">Show the floating Follow-up widget across WeQuote.</div>
			</div>
			<span class="text-bold mr-2">{{widgets.attention ? 'On' : 'Off'}}</span>
			<label class="custom-control custom-control-success custom-switch mb-0">
				<input type="checkbox" class="custom-control-input" [(ngModel)]="widgets.attention" [ngModelOptions]="{ standalone: true }">
				<span class="custom-control-label"></span>
			</label>
		</div>
	</ng-container>

	<div class="flex-weight-1" ui-modal-footer></div>
	<button type="button" class="btn btn-medium mr-2" (click)="modal.close()" [disabled]="disabled" ui-modal-footer>Cancel</button>
	<button type="submit" class="btn btn-primary" (click)="save()" [disabled]="disabled" ui-modal-footer>Save changes</button>
</ui-modal>
